import { UPDATE_THEME } from '../actions/settingsAction';

const initialState = {
  loading: false,
  error: null,
  theme: 0,
};

const settingsReducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case UPDATE_THEME:
      return {
        ...state,
        loading: false,
        theme: action.payload,
      };
    default:
      return state;
  }
};

export default settingsReducer;
